import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { getIconCSSClass } from "../../utils/index";
import BrowserViewGlobal from "../../../Views/BrowserView";
import ActionPointTooltip from "../../ActionPointTooltip";
import useHover from "../../../hooks/useHover";

export default function ModalLink({
  id,
  createNonInternalStream,
  left,
  top,
  tabindex,
  title,
  description,
  iconKind,
  linkKind,
  linkVideoIframe,
  backgroundColor,
}) {
  const [showModal, setShowModal] = useState(false);
  const [hover, hoverProps] = useHover();

  return (
    <BrowserViewGlobal>
      <a
        id={`action-point-${id}`}
        onClick={() => {
          setShowModal(true);
          createNonInternalStream();
        }}
        style={{
          top: `${top}%`,
          left: `${left}%`,
          backgroundColor: `#${backgroundColor}`,
        }}
        className={`view__links__dot ${getIconCSSClass(iconKind, linkKind)}`}
        // title={title}
        tabindex={tabindex}
        {...hoverProps}
      >
        <ActionPointTooltip show={hover} text={title} />
      </a>

      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        className="break-sizing modal-action-point"
      >
        <div className="modal-custom">
          <div
            onClick={() => setShowModal(false)}
            className="modal-custom__close"
          >
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div>
            {description && (
              <div
                className="modal-actionpoint-container"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            {linkVideoIframe && (
              <div
                className="modal-actionpoint-container"
                dangerouslySetInnerHTML={{ __html: linkVideoIframe }}
              />
            )}
          </div>
        </div>
      </Modal>
    </BrowserViewGlobal>
  );
}
